import { ENVS } from '@/utils/environment'
import { APP_WIDGET_PLACEMENT } from './utils'

export const WIDGET_CARD_DICTIONARY = {
  [APP_WIDGET_PLACEMENT.FULL_SCREEN]: {
    placement: APP_WIDGET_PLACEMENT.FULL_SCREEN,
    title: 'Full-screen app',
    description:
      'This application has a full-screen view. To access it, pin this application to the main navigation bar in the Apps view.',
    image: 'widgetFullscreenPlacement',
  },
  [APP_WIDGET_PLACEMENT.SETTINGS]: {
    placement: APP_WIDGET_PLACEMENT.SETTINGS,
    title: 'App settings',
    description:
      'This app provides a Settings view, which you can use to manage its configuration.',
    image: 'widgetSettingsPlacement',
  },
  [APP_WIDGET_PLACEMENT.PLUGIN]: {
    placement: APP_WIDGET_PLACEMENT.PLUGIN,
    title: 'Customer details',
    description:
      'You can find this application in the Customer Details bar in Chats and Archives.',
    image: 'widgetCustomerDetailsPlacement',
  },
  [APP_WIDGET_PLACEMENT.MESSAGE_BOX]: {
    placement: APP_WIDGET_PLACEMENT.MESSAGE_BOX,
    title: 'Message box',
    description:
      'You can find this application in the message box when chatting with customers.',
    image: 'widgetMessageBoxPlacement',
  },
  /* Special case - customProps.agentAppReport === 'true' */
  reports: {
    placement: 'reports',
    title: 'Report',
    description:
      'This app unlocks a new report under Reports for you and your team.',
    image: 'widgetReportsPlacement',
  },
} as const

export const WIDGET_CARD_ORDER = [
  APP_WIDGET_PLACEMENT.PLUGIN,
  APP_WIDGET_PLACEMENT.MESSAGE_BOX,
  APP_WIDGET_PLACEMENT.FULL_SCREEN,
  APP_WIDGET_PLACEMENT.SETTINGS,
  'reports',
]

export const WIDGET_CARD_LINK = {
  CHATS: '/chats',
  REPORTS: '/reports',
} as const

export const CANONICAL_OVERWRITE = {
  [ENVS.PRODUCTION]: {
    woocommerce: 'https://www.livechat.com/woocommerce-chat-ai/',
    wordpress: 'https://www.livechat.com/wordpress-chat-ai/',
    webflow: 'https://www.livechat.com/webflow-chat-ai',
    elementor: 'https://www.livechat.com/elementor-chat-ai',
    unbounce: 'https://www.livechat.com/unbounce-chat-ai',
    magento: 'https://www.livechat.com/magento-chat-ai',
    'magento-2': 'https://www.livechat.com/magento-chat-ai',
    opencart: 'https://www.livechat.com/opencart-chat-ai',
    weebly: 'https://www.livechat.com/weebly-chat-ai',
    wix: 'https://www.livechat.com/wix-chat-ai',
    squarespace: 'https://www.livechat.com/squarespace-live-chat',
    mailchimp: 'https://www.livechat.com/mailchimp-chat-ai',
    'whatsapp-business': 'https://www.livechat.com/whatsapp-business-chat',
    'apple-messages-for-business':
      'https://www.livechat.com/apple-messages-business-chat',
    telegram: 'https://www.livechat.com/telegram-chat-ai',
    zapier: 'https://www.livechat.com/zapier-chat-ai',
  },
}
